import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useIntersectionObserver } from 'react-intersection-observer-hook';
// api
import { getElementsList, getAllLists } from 'api/lists';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import Activities from './ActivitiesSchedule.js';
import SmallReviews from './SmallReviews.js';
import ItemList from 'components/itemList/item';
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
// image
import Star from 'assets/img/ico_star.png';
import IconPaper from 'assets/img/icon-paper.png';
// styles
import './childrenBooks.scss';


const ChildrenBooks = () => {
  const [lists, setLists] = useState([]);
  const [listSelected, setListSelected] = useState(null);
  const [items, setItems] = useState([]);

  const [contentListBottom, { entry }] = useIntersectionObserver();
  const { assignedLibrary } = useAssignedLibrary();

  const { t } = useTranslation(['childrenBooks', 'header']);

  const title = t('pequenoLipareso', { ns: 'header' });

  useEffect(() => {
    const getListsKid = async () => {
      const { data, status } = await getAllLists({ tipo: 5, page_size: 50, fields: 'id,nombre,url' });
      if (status === 200) {
        setLists(data?.results);
        setListSelected(data?.results.length > 0 ? data?.results[0] : null);
      }
    };
    getListsKid();
  }, []);

  useEffect(() => {
    if (listSelected) {
      const getListItems = async () => {
        const { data, status } = await getElementsList(listSelected?.id);
        if (status === 200) {
          setItems(data?.results);
        }
      };
      getListItems();
    }
  }, [listSelected]);

  return (
    <div className="container-fluid px-2 mainDiv">
      <Head title={title} />
      <Row className="px-2 mx-1">
        <Col md={12} className="pl-1">
          <TitleWithLine text={t('littlelibelist')} />
        </Col>
        <Col md={12} className="d-flex subTitleCol p-0 align-items-center">
          <img src={Star} alt="star.png" />
          <h2 className="">{t('novelties')}</h2>
        </Col>
      </Row>
      <Container fluid className="px-2 mx-0">
        <Row className="justify-content-center pl-3 mx-0">
          <Col lg={2} className="px-0 mx-0 pt-3">
            {lists?.map((list, i) => (
              <Col lg={12} className="px-0 ageSelectors">
                <p className={list.url === listSelected?.url && 'active'} onClick={() => setListSelected(list)}>
                  {list?.nombre}
                </p>
              </Col>
            ))}
          </Col>
          <Col lg={10}>
            <Row className="itemsRow">
              {items.map((item, i) => (
                <Col md={3} lg={2} sm={3} key={i} className="mx-3 mt-2">
                  <ItemList key={i} data={item} childList={true} />
                </Col>
              ))}
            </Row>
          </Col>
          <Col md={12} className="d-flex justify-content-center">
            <Link to={`/${assignedLibrary}/lista/news/`} className="global-link mt-5">
              {t('seemorenews')}
            </Link>
          </Col>
        </Row>
        <div className="content-bottom" ref={contentListBottom}></div>
        <Activities />
        <SmallReviews />
        <img src={IconPaper} alt="icon-paper.png" className="m-5 image-icon-paper" />
      </Container>
    </div>
  );
};

export default ChildrenBooks;
